const SvgPrzylgowe60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M32 11v8h-4v2H9.005l-.043 9H17v6h41v-2H19v-6h-8.028l.023-5H58v-2H41v-2h-5v-4h16v-4zM1.996 36l8.004.034V43h7v6h2v-8h-7v-6.957L2.004 34z" />
  </svg>;
export default SvgPrzylgowe60;